import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

import { Empresa } from 'service/api'
import { CreateSlice } from './index'

export type DateSelectors = {
    competenceOpen: dayjs.Dayjs
    competence: dayjs.Dayjs
    day: number
    month: number
    year: number
    page: number
    selectedDate: dayjs.Dayjs
    selectedCompetence: string
    isCurrentCompetence: boolean
    competenceIsAfterToday: boolean
    handleChangeDay: (...event: any[]) => void
    handleChangeMonth: (...event: any[]) => void
    handleChangeYear: (...event: any[]) => void
    handleChangePage: (...event: any[]) => void
    setCompetence: {
        (data: Empresa): void
        (data: string): void
    }
}

export const createDateSelectorsSlice: CreateSlice<DateSelectors> = (
    set,
    get,
) => {
    const instance = dayjs().locale('pt-br')

    return {
        competenceOpen: instance,
        competence: instance,
        day: instance.date(),
        month: instance.month(),
        year: instance.year(),
        page: instance.month() + 1,
        selectedDate: instance,
        selectedCompetence: instance.format('YYYY-MM'),
        isCurrentCompetence: true,
        competenceIsAfterToday: false,
        handleChangeDay: event => {
            const day = +event.target.value

            const newSelectedDate = get().selectedDate.set('date', day)
            const isCurrentCompetence = newSelectedDate.isSame(
                get().competence,
                'month',
            )
            const competenceIsAfterToday = newSelectedDate.isAfter(
                get().competence,
            )

            set({
                day,
                selectedDate: newSelectedDate,
                isCurrentCompetence,
                competenceIsAfterToday,
                selectedCompetence: newSelectedDate.format('YYYY-MM'),
            })
        },
        handleChangeMonth: event => {
            const month = +event.target.value

            const newSelectedDate = get().selectedDate.set('month', month)
            const isCurrentCompetence = newSelectedDate.isSame(
                get().competence,
                'month',
            )
            const competenceIsAfterToday = newSelectedDate.isAfter(
                get().competence,
            )

            set({
                month,
                selectedDate: newSelectedDate,
                isCurrentCompetence,
                competenceIsAfterToday,
                selectedCompetence: newSelectedDate.format('YYYY-MM'),
            })
        },
        handleChangeYear: event => {
            const year = +event.target.value

            const newSelectedDate = get().selectedDate.set('year', year)
            const isCurrentCompetence = newSelectedDate.isSame(
                get().competence,
                'month',
            )
            const competenceIsAfterToday = newSelectedDate.isAfter(
                get().competence,
            )

            set({
                year,
                selectedDate: newSelectedDate,
                isCurrentCompetence,
                competenceIsAfterToday,
                selectedCompetence: newSelectedDate.format('YYYY-MM'),
            })
        },
        handleChangePage: (_, page) => {
            const month = page - 1
            const newSelectedDate = dayjs(get().selectedDate).set(
                'month',
                month,
            )
            const isCurrentCompetence = newSelectedDate.isSame(
                get().competence,
                'month',
            )
            const competenceIsAfterToday = newSelectedDate.isAfter(
                get().competence,
            )

            set({
                page,
                month,
                selectedDate: newSelectedDate,
                isCurrentCompetence,
                competenceIsAfterToday,
                selectedCompetence: newSelectedDate.format('YYYY-MM'),
            })
        },
        setCompetence: data => {
            const state = {} as DateSelectors

            const hoje = dayjs()
            if (typeof data === 'object') {
                const aberta = dayjs(data.competenciaAtual, 'YYYY-MM')
                    .utc()
                    .locale('pt-br')
                    .set('date', hoje.date())

                state.competenceOpen = aberta
                data = aberta.format('YYYY-MM-DD')
            }

            const [year, month, day = '01'] = data.split('-')
            const competence = dayjs(`${year}-${month}-${day}`).locale('pt-br')

            const competenceIsAfterToday = competence.isAfter(dayjs())

            set({
                ...state,
                competence: competence,
                month: competence.month(),
                year: competence.year(),
                page: competence.month() + 1,
                selectedDate: get()
                    .selectedDate.set('year', competence.year())
                    .set('month', competence.month()),
                selectedCompetence: competence.format('YYYY-MM'),
                isCurrentCompetence: true,
                competenceIsAfterToday,
            })
        },
    }
}
